import nodeClient from "./node-client";

export const saveServiceItem = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/service/products/save`,
    payload
  );  
  return response?.data?.result;
};